/* RESPONSIBLE TEAM: team-frontend-tech */
import Predicate from 'predicates/models/predicate';
export default Predicate.extend({
  isEditable: true,
  isStringType: true,
  genericType: 'string',
  goalComparison: 'eq'
});